import { createFileRoute } from '@tanstack/react-router'
import { AppDocs } from '@/app-docs'

export const Route = createFileRoute('/app-docs')({
  component: AppDocs,
})
